<script setup lang="ts">
import Popper from "vue3-popper";

type Props = {
  alt?: string;
};

defineProps<Props>();

type Slots = {
  default(): HTMLElement;
  title?(): HTMLElement;
  hover?(): HTMLElement;
};

defineSlots<Slots>();

const { isTouchDevice } = useDeviceInformation();
</script>

<template>
  <div class="base-tooltip inline text-platform-text-2">
    <ClientOnly>
      <Popper
        :hover="!isTouchDevice"
        :arrow="true"
      >
        <template #content>
          <div
            class="max-w-xs text-xs"
            data-test="base-tooltip-content"
          >
            <p
              v-if="$slots.title"
              class="block mb-1 font-bold uppercase"
            >
              <slot name="title" />
            </p>
            <slot name="default" />
          </div>
        </template>
        <slot name="hover">
          <BaseIcon
            name="circleInfo"
            :size="14"
            class="translate-y-px"
            :alt="alt"
            data-test="base-tooltip-icon"
          />
        </slot>
      </Popper>
    </ClientOnly>
  </div>
</template>

<style>
:root {
  --popper-theme-background-color: #595959;
  --popper-theme-background-color-hover: #595959;
  --popper-theme-text-color: #ffffff;
  --popper-theme-border-width: 0px;
  --popper-theme-border-radius: 5px;
  --popper-theme-padding: 10px 12px;
}
</style>

<style lang="postcss" scoped>
.base-tooltip {
  :deep(.popper) {
    @apply drop-shadow-tooltip;
  }
}
</style>
